import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TextAreaCopyContainer} from "../../../../model/layout.model";
import {TextAreaComponent} from "../text-area/text-area.component";
import {LayoutElementUtil} from "../../../../service/layout/layout-element.service";
import {NgForOf, NgIf} from "@angular/common";
import {TerminalLabelComponent} from "../terminal-label/terminal-label.component";
import {CharacterCounterComponent} from "../character-counter/character-counter.component";
import {DisplayMessageComponent} from "../../../common/display-message/display-message.component";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-text-area-copy-container',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    TerminalLabelComponent,
    TextAreaComponent,
    CharacterCounterComponent,
    DisplayMessageComponent
  ],
  templateUrl: './text-area-copy-container.component.html',
  styleUrl: './text-area-copy-container.component.scss'
})
export class TextAreaCopyContainerComponent {

  @Input() textAreaCopyContainer!: TextAreaCopyContainer;
  @Input() copyToIds: String[] | undefined;
  @Output() copyEvent = new EventEmitter<String[]>();

  constructor(public layoutElementUtil: LayoutElementUtil, private snackBar: MatSnackBar) {
  }

  fireCopyEvent($event: MouseEvent) {
    if (this.copyToIds) {
      let allSuccessful = true;

      try {
        this.copyEvent.emit(this.copyToIds);
      } catch (error) {
        console.error(`Fehler beim Verarbeiten von IDs ${this.copyToIds}:`, error);
        allSuccessful = false;
      }

      if (allSuccessful) {
        this.snackBar.open('Kopieren erfolgreich', 'OK', {
          verticalPosition: 'bottom',
          horizontalPosition: "right"
        });
      }
    }
  }
}
